import React from "react";
import Banner from "../Banner";

const Team = () => {
  return (
    <div>
      <Banner name={"Team"} Title={"Team"} />
    </div>
  );
};

export default Team;
